import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "info-circle",
  "use": "info-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"info-circle\">\n  <path fill-rule=\"evenodd\" d=\"M407,207a8,8,0,1,0,8,8A8,8,0,0,0,407,207Zm-1,4h0.98c0.007,0,.013,0,0.02,0s0.013,0,.02,0H408v0.94c0,0.022.012,0.04,0.012,0.061s-0.011.04-.012,0.061V213h-0.967c-0.012,0-.022.007-0.033,0.007a0.32,0.32,0,0,1-.033-0.007H406v-0.939a0.58,0.58,0,0,1-.013-0.06c0-.021.011-0.039,0.013-0.06V211Zm2.619,8.006H405.38a0.453,0.453,0,0,1,0-.9L406,218v-3l-0.62-.116a0.453,0.453,0,0,1,0-.9h2.514a0.1,0.1,0,0,0,.113-0.058A0.275,0.275,0,0,0,408,214v4l0.619,0.11A0.453,0.453,0,0,1,408.619,219.006Z\" transform=\"translate(-399 -207)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/info-circle.svg
// module id = null
// module chunks = 